<emerald-modal [opened]="popopOpened" [closeOnOutsideClick]="true"
  *ngIf="fieldsVisibility === personaType.VendorRepJobDet" (onDismiss)="updateActions(true)">
  <ng-container>
    <h4>Would you like to delete the {{candidateName}}’s profile?</h4>
  </ng-container>
  <ng-container actions>
    <div class="form-actions">
      <span class="mdc-dialog__button">
        <emerald-button [size]="'Small'" [type]="'Secondary'" Color="primary" (click)="popopOpened = false"
          label="Cancel">
        </emerald-button>
      </span>
      <span class="mdc-dialog__button">
        <emerald-button [size]="'Small'" [type]="'Primary'" Color="primary" (click)="deleteProfile('Deleted')"
          label="Delete">
        </emerald-button>
      </span>
    </div>
  </ng-container>
</emerald-modal>